// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import ChangePasswordForm from '../molecules/ChangePasswordForm';
import FormPageHeadingComponent from '../../common/molecule/FormPageHeading';
import Row from '../../../../common/atoms/Row';
import Col from '../../../../common/atoms/Col';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import Anchor from '../../../../common/atoms/Anchor';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_PASSWORD_LABELS,
  GlobalPasswordsLabels,
  lblChangePwdHeading,
  lblPasswordInfo,
} from '../../../../../utils/labels/globalPassword.labels';

export const ChangePassword = ({
  successMessage,
  errorMessage,
  onSubmit,
  isPLCCFlow,
  isRegisteredUser,
  loginFormErrorMessage,
  isRtpsFlow,
  showForgotPassword,
  newGlobalErrorMessageEnabled,
}) => {
  return (
    <React.Fragment>
      {!isPLCCFlow && (
        <>
          <BodyCopy className="elem-mb-LRG">
            <Anchor
              to="/account?id=profile"
              asPath="/account/profile"
              fontSizeVariation="xlarge"
              anchorVariation="secondary"
              className="elem-mb-LRG"
            >
              <span className="left-arrow"> </span>
              {getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
                GlobalActionsLabels
              )}
            </Anchor>
          </BodyCopy>
          <FormPageHeadingComponent
            heading={getLabelFromCopyOrFromTranslation(
              `${GLOBAL_PASSWORD_LABELS}.${lblChangePwdHeading}`,
              GlobalPasswordsLabels
            )}
            className="margin-none myAccountRightView"
            dataLocator="pi-profileinformationheading"
          />
          <BodyCopy component="div" className="elem-pt-LRG">
            <Row fullBleed>
              <Col
                colSize={{
                  small: 6,
                  medium: 8,
                  large: 12,
                }}
              >
                <BodyCopy
                  data-locator="passwordInstructionTxt"
                  fontSize="fs14"
                  fontFamily="secondary"
                >
                  {getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_PASSWORD_LABELS}.${lblPasswordInfo}`,
                    GlobalPasswordsLabels
                  )}
                </BodyCopy>
              </Col>
            </Row>
          </BodyCopy>
        </>
      )}
      <ChangePasswordForm
        successMessage={successMessage}
        errorMessage={errorMessage}
        onSubmit={onSubmit}
        isPLCCFlow={isPLCCFlow}
        isRegisteredUser={isRegisteredUser}
        loginFormErrorMessage={loginFormErrorMessage}
        isRtpsFlow={isRtpsFlow}
        showForgotPassword={showForgotPassword}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
      />
    </React.Fragment>
  );
};

ChangePassword.propTypes = {
  successMessage: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isPLCCFlow: PropTypes.bool,
  isRegisteredUser: PropTypes.bool,
  loginFormErrorMessage: PropTypes.string,
  isRtpsFlow: PropTypes.bool,
  showForgotPassword: PropTypes.func,
};

ChangePassword.defaultProps = {
  isPLCCFlow: false,
  isRegisteredUser: false,
  loginFormErrorMessage: '',
  isRtpsFlow: false,
  showForgotPassword: () => {},
};
export default ChangePassword;
